module.exports = __webpack_public_path__ + "static/media/cements_chettinad.2b5181bd.jfif";